import { render, staticRenderFns } from "./RechargeBill.vue?vue&type=template&id=4f5564b3&scoped=true&"
import script from "./RechargeBill.vue?vue&type=script&lang=js&"
export * from "./RechargeBill.vue?vue&type=script&lang=js&"
import style0 from "./RechargeBill.vue?vue&type=style&index=0&id=4f5564b3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5564b3",
  null
  
)

export default component.exports